// ==========================================
// Priority Map สำหรับ Series Groups (Clusters)
// Sort ตาม product name prefix
// ค่าน้อย = แสดงก่อน, ไม่มีใน map = Infinity (แสดงล่างสุด)
// ==========================================
export const CLUSTER_PRIORITY: Record<string, number> = {
  // Eversense Women Cologne
  "ESC CH": 1,
  "ESC CT": 2,
  "ESC MO": 3,
  "ESC DD": 4,
  "ESC DN": 5,
  "ESC BN": 6,
  "ESC MD": 7,
  "ESC ME": 8,
  "ESC MT": 9,
  "ESC AC": 10,
  "ESC SV": 11,
  // Eversense Women Deo Roll on
  "ESD EX": 1,
  "ESD SF": 2,
  "ESD WB": 3,
  "ESD DN": 4,
  "ESD PB": 5,
  "ESD PR": 6,
  "ESD PI": 7,
  "ESD IB": 8,
  "ESD IP": 9,
  "ESD IS": 10,
  "ESD SL": 11,
  // Eversense Talcum
  "EST SS": 1,
  "EST BS": 2,
  "EST FR": 3,
  "EST EC": 4,
  "EST AW": 5,
  // VVR Series
  "VVR BC": 1,
  "VVR HP": 2,
  "VVR CC": 3,
  "VVR SW": 4,
  "VVR CW": 5,
  "VVR MS": 6,
  "VVR SV CM": 7,
  "VVR SS": 8,
  "VVR CG": 9,
  // VVE Series
  "VVE SPF": 1,
  "VVE SV": 2,
  "VVE HY": 3,
  "VVE HY LI": 4,
  "VVE MS JY": 5,
  "VVE MS FR": 6,
  "VVE BO": 7,
  // BES Series
  "BES CM": 1,
  "BEC": 2,
  "BES": 3,
  "BES TI": 4,
  "BES CH": 5,
  "BES LP": 6,
  "BES LV": 7,
  "BES GN": 8,
  "BES LH": 9,
  "BES RE": 10,
  "BES MW": 11,
  "BES SH PP": 12,
  "BES SH MP": 13,
  "BES BB": 14,
  "BES HS PI": 15,
  "BES HS GN": 16,
  "BES EX": 17,
  "BES PF": 18,
  "BES NT": 19,
  "BES SC": 20,
  "BES HN": 21,
  "BES PE": 22,
  // BEA Series
  "BEA PI": 1,
  "BEA GN": 2,
  "BEA LB": 3,
  "BEA DB": 4,
  "BEA NT": 5,
  "PUMP": 6,
  "BEA HW": 7,
  // BEC Series
  "BEC EX": 1,
  "BEC PF": 2,
  "BEC SH": 3,
  // BEB Series
  "BEB": 1,
  // BEW Series
  "BEW CL": 1,
  "BEW": 2,
  "BEW PE": 3,
  "BEW AC": 4,
  "BEW TO": 5,
  "BEW WP": 6,
  // TSD Series
  "TSD CS": 1,
  "TSD BD": 2,
  "TSD FR": 3,
  "TSD OC": 4,
  "TSD CL": 5,
  "TSD EN": 6,
  "TSD MP": 7,
  "TSD OD": 8,
  "TSD AI": 9,
  "TSD PM": 10,
  "TSD ZN FU": 11,
  // TSC Series
  "TSC PK": 0,
  "TSC": 1,
  "TSC CS": 2,
  "TSC BS": 3,
  "TSC BC": 4,
  "TSC WD": 5,
  "TSC BD": 6,
  "TSC PF": 7,
  "TSC SP": 8,
  "TSC AI": 9,
  "TSC OD": 10,
  "TSC ZN FU": 11,
  "TSC CO": 12,
  "TSC PRO PM": 13,
  // TSE Series
  "TSE WD": 1,
  "TSE NO": 2,
  "TSE CH": 3,
  // FLE Series
  "FLE DP":1,
  "FLE OA":2,
  "FLE PP":3,
  "FLE PS":4,
  "FLE OR":5,
  "FLE PLUS":6,
  "FLE AF":7,
};

export const getClusterPriority = (clusterKey: string): number => {
  return CLUSTER_PRIORITY[clusterKey] ?? Infinity;
};

// ==========================================
// Priority Map สำหรับ Series (Colors) แยกตาม Cluster
// Sort ตาม last character ของ serie key
// ค่าน้อย = แสดงก่อน, ไม่มีใน map = Infinity (แสดงล่างสุด)
// ==========================================

// Default priority (ใช้เมื่อไม่มี cluster-specific priority)
export const DEFAULT_SERIES_PRIORITY: Record<string, number> = {
  // เพิ่ม color key ตามต้องการ เช่น:
  // 'W': 1,  // สีขาว
  // 'B': 2,  // สีดำ
  // 'Y': 3,  // สีเหลือง
};

// Cluster-specific priority (กำหนด priority แยกตาม cluster)
export const CLUSTER_SERIES_PRIORITY: Record<string, Record<string, number>> = {
  // ตัวอย่าง:
  // Eversense Women Cologne
  // 'ESC CH':{'1': 1, '3': 2, '4': 3},
  // 'ESC CT':{'1': 1, '3': 2, '4': 3},
  // 'ESC MO':{'1': 2, '3': 1, '4': 3},
  // 'ESC DD':{'1': 2, '3': 1, '4': 3},
  // 'ESC DN':{'1': 2, '3': 1, '4': 3},
  // 'ESC BN':{'1': 2, '3': 1, '4': 3},
  // 'ESC MD':{'1': 2, '3': 1, '4': 3},
  // 'ESC ME':{'1': 2, '3': 1, '4': 3},
  // 'ESC MT':{'1': 2, '3': 1, '4': 3},
  // 'ESC AC':{'1': 2, '3': 1, '4': 3},
  // 'ESC SV':{'1': 2, '3': 1, '4': 3},
  'FLE DP':{'5':1,'2':2,'3':3},
  'FLE PP':{'4':1,'2':2,'3':3},
  'FLE PS':{'7':1,'2':2,'3':3},
  'FLE PLUS':{'5':1,'4':2},
};

export const getSeriesPriority = (
  seriesKey: string,
  clusterKey?: string
): number => {
  // ถ้ามี cluster key และมี priority เฉพาะ cluster นั้น ให้ใช้
  if (clusterKey && CLUSTER_SERIES_PRIORITY[clusterKey]) {
    const priority = CLUSTER_SERIES_PRIORITY[clusterKey][seriesKey];
    if (priority !== undefined) {
      return priority;
    }
  }

  // ถ้ามี default priority ให้ใช้
  if (DEFAULT_SERIES_PRIORITY[seriesKey] !== undefined) {
    return DEFAULT_SERIES_PRIORITY[seriesKey];
  }

  // Fallback: เรียงตาม alphabetical order ของ color code (seriesKey)
  // ใช้ charCodeAt เพื่อให้เรียงตามลำดับตัวอักษร/ตัวเลข
  // เช่น '1' = 49, '3' = 51, 'A' = 65, 'B' = 66, 'W' = 87
  return seriesKey.charCodeAt(0) + 1000; // +1000 เพื่อให้ priority ต่ำกว่าที่ config ไว้
};
